import { get, post, put } from './_httpClient';

export async function addClassifications({ payload }) {
  const { status, message, data } = await post(
    '/clp/classifications-final/hard-skill',
    payload,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateClassifications({
  divisionInstitutionsId,
  payload,
}) {
  return put(
    `/clp/classifications-final/hard-skill/${divisionInstitutionsId}`,
    payload,
  );
}

export async function getClassificationsHardskill({
  pageSize,
  page,
  filterBy = '',
  batchId,
}) {
  const { status, message, data } = await get(
    `/clp/classifications-final/hard-skill?pageSize=${pageSize}&page=${page}&filterBy=${filterBy}&batchId=${batchId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getClassificationsHardskillByDivisiLembagaId({ id }) {
  const { status, message, data } = await get(
    `/clp/classifications-final/hard-skill/division-institutions/${id}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getClassificationsBCF({
  pageSize,
  page,
  filterBy = '',
  batchId,
} = {}) {
  const params = {};
  if (pageSize) params.pageSize = pageSize;
  if (page) params.page = page;
  if (filterBy) params.filterBy = filterBy;
  if (batchId) params.batchId = batchId;
  const queryString = new URLSearchParams(params).toString();
  const { status, message, data } = await get(
    `/clp/classifications-final/bcf${queryString ? `?${queryString}` : ''}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addClassificationsBCF({ payload }) {
  const { status, message, data } = await post(
    '/clp/classifications-final/bcf',
    payload,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateClassificationsBCF({ batchId, payload }) {
  return put(`/clp/classifications-final/bcf/${batchId}`, payload);
}

export async function getClassificationsBCFByUserId({ id }) {
  const { status, message, data } = await get(
    `/clp/evaluations-final/students/${id}/bcf`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getClassificationsSoftskill({
  pageSize,
  page,
  filterBy = '',
  batchId,
} = {}) {
  const params = {};
  if (pageSize) params.pageSize = pageSize;
  if (page) params.page = page;
  if (filterBy) params.filterBy = filterBy;
  if (batchId) params.batchId = batchId;
  const queryString = new URLSearchParams(params).toString();
  const { status, message, data } = await get(
    `/clp/classifications-final/soft-skill${queryString ? `?${queryString}` : ''}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getClassificationsPAT() {
  const { status, message, data } = await get(`/clp/classifications-pat`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

/**
 * Classification types selectable for a context. Pass `batchId` to let the backend
 * resolve the right set from the batch's formula version (v1 -> PAT/CB/ATT, v2 -> CB),
 * or `domain` to force one explicitly.
 */
export async function getClassificationFinalTypes({ domain, batchId } = {}) {
  const params = {};
  if (domain) params.domain = domain;
  if (batchId) params.batchId = batchId;
  const queryString = new URLSearchParams(params).toString();
  const { status, message, data } = await get(
    `/clp/classifications-final/types${queryString ? `?${queryString}` : ''}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
